import React from 'react';
import { TextField, Box, Typography } from "@mui/material";
import { isMobile } from "../App/utils";
import { colorText } from "../App/theme";

export const VectorDBTools = (params) => {
    const {
        embeddingConfigured, KBData, debouncedHandleSearch, handleSearchOnEnter, itemsVectorDB
    } = params;

    return (
        <>
            {embeddingConfigured && KBData?.embeddingModel && (
                <Box mb={3}>
                    <Typography variant="body2" sx={{ color: colorText, mb: 2 }}>
                        Search your knowledge base using semantic search. Items are retrieved directly from VectorDB.
                    </Typography>
                    <TextField
                        label="Search by meaning"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => debouncedHandleSearch(e.target.value)}
                        onKeyPress={(e) => {
                            handleSearchOnEnter(e)
                        }}
                        placeholder="Enter your search query..."
                        size="small"
                        InputProps={{ style: { height: '40px' } }}
                    />
                </Box>
            )}
        </>
    );
}
